"use strict";
export async function openURL(url) {
  return window.open(url);
}
export async function canOpenURL(_url) {
  return true;
}
